import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { FormattedMessage } from 'react-intl';

export class SurveyCompleteModal extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      analyticsCalled: false
    };
  }

  componentDidUpdate () {
    if (!this.state.analyticsCalled) {
      const { whichModal = '' } = this.props;
      if (whichModal && whichModal !== 'SurveyCompleteModal') return;
      this.props.calendarSurveyAnalytics('survey completed');
      this.setState({ analyticsCalled: true });
    }
  }

  render () {
    const { showModal, toggleModal } = this.props;
    return (
      <BootstrapModal
        showModal={showModal}
        toggleModal={toggleModal}
        modalClass="host-survey-modal"
        header={
          <div>
            <h3>
              <FormattedMessage
                id="shared.survey_complete.header"
                defaultMessage="Thanks for Letting Us Know"
              />
            </h3>
          </div>
        }
        body={
          <div>
            <p className="margin-xl-bottom">
              <FormattedMessage
                id="shared.survey_complete.header_text"
                defaultMessage="We want to help you keep your availability updated in Peerspace. "
              />
              <a href="https://support.peerspace.com/hc/en-us">
                <FormattedMessage
                  id="shared.survey_complete.header_link"
                  defaultMessage="Feel free to contact us here for help."
                />
              </a>
            </p>
            <button
              onClick={()=>toggleModal('')}
              className="btn btn-primary btn-block classic"
            >
              <FormattedMessage
                id="shared.why_cant_sync.button_done"
                defaultMessage="Done"
              />
            </button>
          </div>
        }
        bodyClass="sync-modal-body text-center"
      />
    );
  }
}

SurveyCompleteModal.propTypes = {
  showModal: PropTypes.bool,
  updateSurveyState: PropTypes.func,
  toggleModal: PropTypes.func,
  changeModal: PropTypes.func,
  callback: PropTypes.func,
  calendarSurveyAnalytics: PropTypes.func
};
